var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemDefinition)?_c(_vm.itemDefinition.viewType,{tag:"component",attrs:{"itemDefinition":_vm.itemDefinition}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }